import type { ActivityItem } from '../data/types'

type RecentActivityProps = {
  activities: ActivityItem[]
}

const activityColors: Record<ActivityItem['type'], string> = {
  approval: 'bg-emerald-500',
  create: 'bg-blue-500',
  update: 'bg-amber-500',
  system: 'bg-slate-400',
}

function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

// function getActivityDetail(activity: ActivityItem): string {
//   if (!activity.details) return activity.action

//   try {
//     const details = JSON.parse(activity.details) as { message?: string }
//     return details.message ?? activity.action
//   } catch {
//     return activity.action
//   }
// }

export function RecentActivity({ activities }: RecentActivityProps) {
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-6">
      <div className="mb-4">
        <h2 className="text-base font-semibold text-slate-900">လတ်တလော လှုပ်ရှားမှုများ</h2>
        <p className="text-sm text-slate-500">နောက်ဆုံးပေါ် စနစ်နှင့် တာဝန်ခံများ၏ ဆောင်ရွက်ချက်များ</p>
      </div>

      <ol className="relative space-y-0">
        {activities.map((activity, index) => (
          <li key={activity.id} className="relative flex gap-4 pb-6 last:pb-0">
            {index < activities.length - 1 && (
              <span
                className="absolute left-[7px] top-4 h-full w-px bg-slate-200"
                aria-hidden="true"
              />
            )}
            <span
              className={`relative z-10 mt-1 h-3.5 w-3.5 shrink-0 rounded-full ring-4 ring-white ${activityColors[activity.type]}`}
              aria-hidden="true"
            />
            <div className="min-w-0 flex-1">
              <p className="text-sm text-slate-800">
                <span className="font-semibold text-slate-900">{activity.user}</span>{' '}
                {activity.details?.trim() || activity.action}
              </p>
              <time
                className="mt-0.5 block text-xs text-slate-400"
                dateTime={activity.timestamp}
              >
                {formatDateTime(activity.timestamp)}
              </time>
            </div>
          </li>
        ))}
      </ol>
    </section>
  )
}